import axiosInstance from 'axios'
import { AxiosRequestConfig } from 'axios'

export const request = <R = any, D = any>(url: string, options?: AxiosRequestConfig<D>): Promise<R> =>
  axiosInstance.request({
    url,
    ...options,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

export default request
